import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotifications = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.607 13.571C6.695 13.839 6.879 14.075 7.13 14.242C7.381 14.41 7.686 14.5 8 14.5C8.313 14.5 8.619 14.41 8.87 14.242C9.121 14.075 9.304 13.839 9.393 13.571",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 3.357V1.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 3.357C9.026 3.357 10.01 3.776 10.736 4.523C11.461 5.269 11.869 6.281 11.869 7.337C11.869 11.075 12.643 11.714 12.643 11.714H3.357C3.357 11.714 4.131 10.698 4.131 7.337C4.131 6.281 4.538 5.269 5.264 4.523C5.99 3.776 6.974 3.357 8 3.357V3.357Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNotifications;
